// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__3Pe2r","icon":"search_icon__J1Bgp","input":"search_input__3jcic","button":"search_button__15yp7"};